import React from 'react'

import { IconProps } from 'types/icon.type'

export const InstagramIcon: React.FC<IconProps> = ({ color = '#89AC76' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
    >
      <g clipPath="url(#clip0_2011_9)">
        <path
          d="M13.4442 3.16557C16.9712 3.16557 17.4192 3.16557 18.8192 3.22157C19.6592 3.22157 20.4992 3.38957 21.2822 3.66947C22.4582 4.11737 23.3542 5.01327 23.8022 6.18907C24.0822 6.97297 24.2502 7.81277 24.2502 8.65267V19.403C24.2502 20.2429 24.0822 21.0827 23.8022 21.8666C23.3542 23.0424 22.4582 23.9383 21.2822 24.3862C20.4992 24.6661 19.6592 24.8341 18.8192 24.8341C17.4192 24.8901 16.9712 24.8901 13.4442 24.8901C9.91681 24.8901 9.46891 24.8901 8.06921 24.8341C7.22941 24.8341 6.38951 24.6661 5.60571 24.3862C4.42991 23.9383 3.5341 22.9864 3.0862 21.8666C2.8062 21.0827 2.63831 20.2429 2.63831 19.403V8.65267C2.63831 7.81277 2.8062 6.97297 3.0862 6.18907C3.5341 5.06927 4.42991 4.11737 5.60571 3.66947C6.38951 3.38957 7.22941 3.22157 8.06921 3.22157C9.46891 3.22157 9.91681 3.16557 13.4442 3.16557ZM13.4442 0.813973C9.80481 0.813973 9.35691 0.813972 7.95721 0.869972C6.83741 0.869972 5.77361 1.09387 4.70991 1.48587C2.91821 2.15777 1.4625 3.61347 0.790604 5.40517C0.398704 6.46907 0.174805 7.53287 0.174805 8.65267V19.627C0.174805 20.7468 0.454703 21.8106 0.846603 22.8184C1.5185 24.6102 2.97421 26.0659 4.76581 26.7378C5.82961 27.1298 6.89341 27.3537 8.01321 27.3537C9.41291 27.4097 9.91681 27.4097 13.5002 27.4097C17.0832 27.4097 17.5872 27.4097 18.9872 27.3537C20.1072 27.3537 21.1702 27.1298 22.2342 26.7378C24.0262 26.0659 25.4822 24.6102 26.1532 22.8184C26.5452 21.7546 26.7692 20.6908 26.7692 19.571V8.59667C26.7692 7.47687 26.5452 6.41307 26.1532 5.34917C25.4822 3.55747 24.0262 2.10177 22.2342 1.42987C21.1702 1.03787 20.1072 0.813973 18.9872 0.813973C17.5872 0.757973 17.1392 0.757973 13.4442 0.813973Z"
          fill={color}
        />
        <path
          d="M13.444 7.25293C9.69268 7.25293 6.61328 10.3324 6.61328 14.0838C6.61328 17.8352 9.69268 20.9147 13.444 20.9147C17.195 20.9147 20.275 17.8352 20.275 14.0838C20.275 10.3324 17.251 7.25293 13.444 7.25293ZM13.444 18.5071C10.9804 18.5071 9.02078 16.4915 9.02078 14.0838C9.02078 11.6762 11.0364 9.66053 13.444 9.66053C15.851 9.66053 17.867 11.6762 17.867 14.0838C17.867 16.5474 15.907 18.5071 13.444 18.5071Z"
          fill={color}
        />
        <path
          d="M20.5547 8.59662C21.4507 8.59662 22.1777 7.86962 22.1777 6.97292C22.1777 6.07612 21.4507 5.34912 20.5547 5.34912C19.6577 5.34912 18.9307 6.07612 18.9307 6.97292C18.9307 7.86962 19.6577 8.59662 20.5547 8.59662Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2011_9">
          <rect width="27" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
